/**
 * Embedded video controller plugin for jQuery
 * Implements easy controls for embedded vimeo and youtube videos
 *
 * @author antroxim@gmail.com
 */

(function ($) {
  'use strict';


}(jQuery));


(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Drupal.behaviors.videoController = {
    attach: function (context, settings) {
      var youtubeApi = false;
      var vimeoApi = false;

      $('iframe').each(function (i) {
        var src = $(this).attr('src');

        if (typeof src !== typeof undefined && src !== false) {
          // Checking if any youtube players with JSapi enabled
          if (src.includes("youtube.com") && src.includes("enablejsapi=1")) {
            $(this).attr('id', '#youtube-player-' + i).addClass('youtube-iframe-api');
            youtubeApi = true;
          }
          // Checking if any vimeo embeds
          if (src.includes("vimeo.com")) {
            $(this).attr('id', 'id', '#vimeo-player-' + i).addClass('vimeo-iframe-api');
            vimeoApi = true;
          }
        }

      });

      // Getting Youtube / Vimeo JS iframe API
      if (!window.YT && youtubeApi) {
        $.getScript('https://www.youtube.com/iframe_api');
      }
      if (!window.Vimeo && vimeoApi) {
        $.getScript('https://player.vimeo.com/api/player.js', function () {
          onVimeoPlayerAPIReady();
        });
      }

      // Vimeo API ready
      function onVimeoPlayerAPIReady() {
        $('iframe.vimeo-iframe-api').each(function (i) {
          /* global Vimeo */
          $(this).data('player', {
            type: 'vimeo',
            player: new Vimeo.Player(this)
          });
          assignControlls($(this));
        });
      }

      // Youtube API ready callback
      window.onYouTubePlayerAPIReady = function () {
        $('iframe.youtube-iframe-api').each(function () {
          /* global YT */
          var id = $(this).attr('id');
          $(this).data('player', {
            type: 'youtube', player: new YT.Player(id, {
              events: {
                onReady: youtubePlayerReady,
                onStateChange: youtubePlayerStateChange
              }
            })
          });
        });
      };

      // Youtube player ready callback
      function youtubePlayerReady(event) {
        var iframe = $(event.target.a);
        assignControlls(iframe);
      }

      // Passing events to iframe object
      function youtubePlayerStateChange(event) {
        var iframe = $(event.target.a);
        switch (event.data) {
          case 0:
            iframe.trigger('onStop');
            break;
          case 1:
            iframe.trigger('onPlay');
            break;
          case 2:
            iframe.trigger('onPause');
            break;

          default:
            break;
        }
      }

      // Assigning controlls to player to use them
      function assignControlls(iframe) {
        var player = iframe.data('player');
        if(!player) return;
        switch (player.type) {
          case 'vimeo':
            // Assigning player controls
            player.controls = {
              play: function () {
                player.player.play();
              },
              pause: function () {
                player.player.pause();
              },
              stop: function () {
                player.player.unload();
              }
            };

            // Assigning Vimeo player events
            player.player.on('play', function () {
              iframe.trigger('onPlay');
            });
            player.player.on('pause', function () {
              iframe.trigger('onPause');
            });
            player.player.on('ended', function () {
              iframe.trigger('onStop');
            });

            break;

          case 'youtube':
            player.controls = {
              play: function () {
                player.player.playVideo();
              },
              pause: function () {
                player.player.pauseVideo();
              },
              stop: function () {
                player.player.stopVideo();
              }
            };
            break;

          default:
            break;
        }
      }
    }
  };
})(Drupal, jQuery);
